import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import {
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { User } from 'src/app/shared/models/security/user';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { PARAM_LABEL_BENEFICIAIRE } from 'src/app/core/services/constant/constants.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { NotificationEmail, SendEmail } from 'src/app/shared/models/notificationEmail';
import { Prestation } from 'src/app/shared/models/prestation';
import { NotificationType } from 'src/app/shared/enums/notification-type.enum';

@Component({
	selector: 'app-user-modal-ajout-form',
	templateUrl: './user-modal-ajout-form.component.html',
	styleUrls: ['./user-modal-ajout-form.component.scss']
})
export class UserModalAjoutFormComponent implements OnInit {
	LABEL_BENEFICIAIRE: string;
	serviceCenter: ServiceCenter;
	enumCompetences;

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	isPreferencesActive = false;
	notificationEmail : NotificationEmail;
	sendMail = new SendEmail();
	listNotificationType = NotificationType;

	user = new User();

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = new FormGroup({
		firstName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		lastName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		// address: new FormControl(new Address().label, [
		// 	//Validators.required,
		// 	//Validators.maxLength(60)
		// ]),
		birthDate: new FormControl<Date>(null),
		phone: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
		active: new FormControl(),
		profile: new FormControl(),
		email: new FormControl('', [
			Validators.required,
			Validators.email]),
		username: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.pattern(this.NAME_PATTERN)
		]),
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	@Output() updateListing = new EventEmitter();


	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private toastService: ToastService
	) {}

	ngOnInit(): void {

	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.facade.userService
			.addUser(this.user)
			.subscribe({
				next: (savedUser: User) => {
					this.isValidateButtonClicked.value = false;
					this.bsModalRef.hide();
					this.updateListing.emit(this.user);
					this.facade.notificationEmailService.getAllNotificationEmail().subscribe({
						next: (val) => {
							console.log(this.user);
							this.notificationEmail = val.find(x => x.type == this.listNotificationType.CREATION_COMPTE)
							this.sendMail.email = this.user.email;
							this.sendMail.notificationEmail = this.notificationEmail;
							this.sendMail.prestation = new Prestation();
							this.sendMail.user = savedUser;
							console.log(this.sendMail);
							this.facade.notificationEmailService.sendEmail(this.sendMail).subscribe({
								complete: () =>{
									this.user.id = savedUser.id;
								}
							})
						}
					})
				},
				error: (err: ErrorResponse) => {
					this.isValidateButtonClicked.value = false;
					this.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
	}
}
